<template lang="pug">
.general
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h2.primary--text {{$t('Shipment.general')}}
    v-row
      v-col.d-flex.align-center
        h3.primaryHover--text {{$t('Shipment.info')}}
    v-row
      v-col
        v-text-field(
          :value="instance.businessScope && instance.businessScope.path",
          :label="$tc('BusinessScope._name', 1)",
          disabled,
        )
      v-col
        v-text-field(
          :value="instance.bundleKey",
          :label="$t('Shipment.bundleKey')",
          disabled,
        )
      v-col
        v-text-field(
          :value="instance.externalId",
          :label="$t('Shipment.externalId')",
          disabled,
        )
      v-col
        app-datetime-picker(
          :value="instance.createdAt",
          :label="$t('Shipment.createdAt')",
          disabled,
        )
      v-col
        app-datetime-picker(
          :value="instance.modifiedAt",
          :label="$t('Shipment.modifiedAt')",
          disabled,
        )
    v-row
      v-col(cols="3")
        v-text-field(
          v-model="instance.shipperReference",
          :label="$t('Shipment.shipperReference')",
          :error-messages="errors['shipment.shipperReference']",
          :error="!!errors['shipment.shipperReference']"
        )
      v-col(cols="3")
        v-text-field(
          v-model="instance.receiverReference",
          :label="$t('Shipment.receiverReference')",
          :error-messages="errors['shipment.receiverReference']",
          :error="!!errors['shipment.receiverReference']"
        )
      v-col(cols="3")
        v-text-field(
          v-model="instance.shoReference",
          :label="$t('Shipment.shoReference')",
          :error-messages="errors['shipment.shoReference']",
          :error="!!errors['shipment.shoReference']"
        )
      v-col(cols="3")
        v-select(
            :label="$t('Shipment.status')",
            :items="shipmentStatuses",
            item-text="name",
            item-value="id",
            :loading="statusLoading",
            v-model="instance.statusId",
          )
      v-col
        v-text-field(
          v-model="instance.incotermCode",
          :label="$t('Shipment.incotermCode')",
          :error-messages="errors['shipment.incotermCode']",
          :error="!!errors['shipment.incotermCode']"
        )
      v-col
        v-text-field(
            v-model="instance.incotermLocation",
            :label="$t('Shipment.incotermLocation')",
            :error-messages="errors['shipment.incotermLocation']",
            :error="!!errors['shipment.incotermLocation']"
          )
      v-col
        v-text-field(
          v-model="instance.transportMode",
          :label="$t('Shipment.transportMode')",
          :error-messages="errors['shipment.transportMode']",
          :error="!!errors['shipment.transportMode']"
        )
      v-col
        v-text-field(
          v-model="instance.shipmentType",
          :label="$t('Shipment.shipmentType')",
          :error-messages="errors['shipment.shipmentType']",
          :error="!!errors['shipment.shipmentType']"
        )
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h3.primaryHover--text {{$t('User.information')}}
    v-row
      v-col
        v-text-field(
          :value="instance.user ? instance.user.fullName : ''",
          :label="$t('User.fullName')",
          disabled,
        )
      v-col
        v-text-field(
          :value="instance.user ? instance.user.email: ''",
          :label="$t('User.email')",
          disabled,
        )
      v-col
        v-text-field(
          :value="instance.user ? instance.user.phoneNumber : ''",
          :label="$t('User.phoneNumber')",
          disabled,
        )
      v-col
        v-text-field(
          :value="instance.externalUserReference",
          :label="$t('Shipment.externalUserReference')",
          disabled,
        )
</template>

<script>
import EntityMixin from '@/mixins';
import axios from 'axios';

export default {
  mixins: [EntityMixin],
  props: {
    slotProps: null,
    entity: null,
    loading: null,
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    shipmentStatuses: [],
    statusLoading: true,
  }),
  async created() {
    try {
      this.shipmentStatuses = (await axios.get('Status?where[]=entity="Shipment"', {params: { pageSize: -1 }})).data.data;
    } catch (e) {
      console.log(this.$cleanString(e))
    } finally {
      this.statusLoading = false;
    }
  },
}
</script>
